const AIDesk = {
  "结束会话": "終了",
  "转人工服务": "人工サービスに転送する",
  "跳转": "リンク",
  "立即填写": "今すぐ記入",
  "已提交": "提出済み",
  "提交": "提出する",
  "查看内容": "内容を表示",
  "请填写必填项":"必須項目を入力してください",
  "请输入内容":"内容を入力してください",
  "如果满意请给好评哦～":"ご満足いただけましたら、ぜひ良いレビューをお願いします〜",
  "请对本次服务进行评价": "このサービスについて評価をお願いします",
  "提交评价": "評価を提出する",
  "服务评价": "サービス評価",
  "并发限制": "現在アクセスが集中しております。しばらくしてから再度お試しください",
  "分支选项异常": "コンテンツに異常があります。タスクフローの設定を確認してください",
  "满意": "満足",
  "不满意": "不満",
  "感谢您的反馈，我们会持续优化改进": "フィードバックありがとうございます、改善を続けます",
  "您遇到了哪方面的问题": "どのような問題がありましたか",
  "其他反馈内容": "その他のフィードバック",
  "取消": "キャンセル",
  "答非所问": "関係ない回答",
  "未匹配相关内容": "関連する内容が見つかりません",
  "信息错误": "情報が間違っています",
  "上下文理解错误": "文脈の理解誤り",
  "格式不规范": "形式が不適切",
  "内容不完整": "内容が不完全",
  "file 大小超过 100MB，无法发送": "ファイルサイズが100MBを超えているため送信できません",
  "image 大小超过 20MB，无法发送": "画像のサイズが20MBを超えているため送信できません",
  "video 大小超过 100MB，无法发送": "動画のサイズが100MBを超えているため送信できません",
  "提交成功": "送信が成功しました",
  "userID 只能包含可打印 ASCII 字符": "UserIDは印字可能なASCII文字のみを含める必要があります",
  "userID 不能包含'administrator'": "UserIDに'administrator'を含めることはできません",
  "userID 长度不能超过45字节": "UserIDの長さは45バイトを超えてはいけません",
  "我们想知道你对此回答不满意的原因，你认为更好的回答是什么？": "皆様からのフィードバックをお待ちしております。改善に役立つご提案がございましたら、ぜひお聞かせください。",
  "排队等待中": "ただいま待機中",
  "排队等待话术": "申し訳ございません、現在すべてのカスタマーサービスが対応中です。しばらくお待ちください。ご理解いただきありがとうございます。",
  "当前前方排队人数": "現在の前方待機人数",
  "结束排队": "待機を終了する",
  "评价提交超过3分钟，无法更改。感谢您的反馈！": "レビューは投稿から3分経過すると変更できません。",
  "不能发送空白消息": "空白のメッセージは送信できません",
  "确认转人工": "人工サービスに転送する",
}
export default AIDesk;
